import { render, staticRenderFns } from "./TimeDisplay.vue?vue&type=template&id=41c122e4&scoped=true&"
import script from "./TimeDisplay.vue?vue&type=script&lang=js&"
export * from "./TimeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c122e4",
  null
  
)

export default component.exports